import React, { useEffect, useRef } from 'react';
import Lottie from 'lottie-react';
import classNameBind from 'classnames/bind';
import animation from './animation.json';
import styles from './Preloader.module.css';

const bindClasses = classNameBind.bind(styles);

const Preloader = ({ testRef }) => {
  const lottieRef = testRef || useRef();
  const lottieInitPreloader = window.lottieInitPreloaderInstance;

  useEffect(() => {
    if (document.getElementById('initial-lottie-overlay')) {
      document.getElementById('initial-lottie-overlay').remove();
    }

    // secured just in case lottie is not passed to window
    if (lottieInitPreloader) {
      lottieRef.current.goToAndPlay(lottieInitPreloader.currentFrame, true);
    }
  }, [lottieInitPreloader]);

  return (
    <div className={bindClasses('preloader')} data-ppuc-id="Preloader">
      <Lottie animationData={animation} lottieRef={lottieRef} />
    </div>
  );
};

export default Preloader;
